import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * This checks if the current environment is FedRamp and returns false.
 * The FF is just a fail-safe to not change existing behaviour.
 */
export const isCMDBEnabledInEnvironment = (cmdbDisabledInFedRAMPForTenant: boolean | null) =>
	!isFedRamp() ||
	(isFedRamp() &&
		(fg('use_cmdb_scr12_enabled')
			? cmdbDisabledInFedRAMPForTenant != null && !cmdbDisabledInFedRAMPForTenant
			: fg('jsm-assets-fedramp-ui')));
